<template>
  <div class="container-fluid">
    <div class="row">

        <div class="col-md-12">
          <div class="row">

            <div class="col-lg-12 col-md-12 box-margin height-card">
                <div class="card">

                <el-collapse accordion class="hover-eti">
                    <el-collapse-item name="1" >
                        <template slot="title">
                            <h3><i class="el-icon-s-grid"></i> &nbsp; Lista de Filtros</h3>
                        </template>

                        <div class="card-body">
                            <div class="row">
                            <div class="col-md-4 col-sm-4 col-lg-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha</label>
                                    <input @change="coti_asesor_neta(filtrar_fecha,filtro_anio,filtro_mes,id_user)" type="date" class="form-control" v-model="filtrar_fecha" >
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-4 col-lg-4">
                                <div class="form-group">
                                    <label for="estado">Mes</label>
                                    <select  @change="coti_asesor_neta(filtrar_fecha,filtro_anio,filtro_mes,id_user)" class="custom-select" v-model="filtro_mes">
                                        <option value="0">Selecione el mes</option>
                                        <option v-for="mes in mesesList" :key="mes.id" :value="mes.id" v-text="mes.nombre"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-4 col-lg-4">
                                <div class="form-group">
                                    <label for="estado">Año</label>
                                    <select class="custom-select" v-model="filtro_anio" @change="coti_asesor_neta(filtrar_fecha,filtro_anio,filtro_mes,id_user)">
                                        <option value="0">Selecione el año</option>
                                        <option v-for="anios in listAnio" :key="anios" :value="anios" v-text="anios"></option>

                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-4 col-lg-4" v-if="usuario.cargo == 'Administrador'">
                                <div class="form-group">
                                    <label for="estado">Asesores</label>
                                    <v-select  multiple @input="coti_asesor_neta(filtrar_fecha, filtro_anio, filtro_mes, id_user)"
                                            v-model="id_user"
                                            label="fullname"
                                            :options="users_list"
                                            placeholder="Buscar Asesor..."
                                        >
                                    <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 col-lg-4">
                                <div class="form-group">
                                    <label >Borrar Filtros</label>
                                    <button type="button" class="btn btn-success btn-block" @click="reset()" >Borrar Filtros</button>
                                </div>
                            </div>
                            </div>
                        </div>

                          </el-collapse-item>
                </el-collapse>
                <!--FIN DE FILTROS DE BUSQUEDA-->

                <div class="car-body">
                    <div class="row" style="margin-left: 7px; margin-right: 7px;">

                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 col-lg-3">
                                <!-- Card -->
                                <div class="card box-margin" >
                                    <div class="card-body" style=" background-color: #4472c4; color: white; border-radius: 40px 40px 40px 40px;">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <!-- Title -->
                                                <h6 class="text-uppercase font-14" style="color: white">
                                                    Total Acumulado
                                                </h6>

                                                <!-- Heading -->
                                                <span class="font-24 text-dark mb-0" style="color: white !important" v-text="'$ ' +  formatPrice(asesores_coti_categoria.ganadas)">
                                                </span>
                                            </div>

                                            <div class="col-auto">
                                                <!-- Icon -->
                                                <div class="icon">
                                                  <i class="fas fa-shopping-bag fa-3x"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 col-lg-3">
                                <!-- Card -->
                                <div class="card box-margin" >
                                    <div class="card-body" style="background-color: rgb(156, 39, 176); color: white; border-radius: 40px 40px 40px 40px;">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <!-- Title -->
                                                <h6 class="font-14 text-uppercase" style="color: white">
                                                    Ingreso Merbrok
                                                </h6>
                                                <!-- Heading -->
                                                <span class="font-24 text-dark mb-0" style="color: white !important" v-text="'$ ' + formatPrice(ingreso_merbrok_por_asesor)">
                                                </span>
                                            </div>
                                            <div class="col-auto">
                                                <!-- Icon -->
                                                <div class="icon">
                                                  <i class="fas fa-dollar-sign fa-3x"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 col-lg-3">
                                <!-- Card -->
                                <div class="card box-margin" >
                                    <div class="card-body" style="background-color:#43A047; color: white; border-radius: 40px 40px 40px 40px;">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <!-- Title -->
                                                <h6 class="font-14 text-uppercase" style="color: white !important">
                                                    Pagos y Bonos
                                                </h6>
                                                <!-- Heading -->
                                                <span class="font-24 text-dark mb-0" style="color: white !important" v-text="'$ ' + formatPrice(pagos_bonos_por_asesor)">
                                                </span>
                                            </div>
                                            <div class="col-auto">
                                                <!-- Icon -->
                                                <div class="icon">
                                                  <i class="fas fa-users fa-3x"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-xl-3 col-lg-3">
                                <!-- Card -->
                                <div class="card box-margin" >
                                    <div class="card-body"  style="background-color: rgb(233, 30, 99); color: white; border-radius: 40px 40px 40px 40px;">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <!-- Title -->
                                                <h6 class="font-14 text-uppercase" style="color: white !important">
                                                    Utilidad
                                                </h6>
                                                <!-- Heading -->
                                                <span class="font-24 text-dark mb-0" style="color: white !important" v-text="'$ ' + formatPrice(utilidad_por_asesor)">
                                                </span>
                                            </div>
                                            <div class="col-auto">
                                                <!-- Icon -->
                                                <div class="icon">
                                                  <i class="fas fa-money-bill-alt fa-3x"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-md-4 col-xl-4" style="display: none">
                                <!-- Card -->
                                <div class="card box-margin">
                                    <div class="card-body">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <!-- Title -->
                                                <h6 class="font-14 text-uppercase">
                                                    Rentabilidad
                                                </h6>
                                                <!-- Heading -->
                                                <span class="font-24 text-dark mb-0" v-text="formatPrice(rentabilidad_por_asesor) + '%'">
                                                </span>
                                            </div>
                                            <div class="col-auto">
                                                <!-- Icon -->
                                                <div class="icon">
                                                    <i class="fas fa-percent fa-3x" style="color: #6e00ff !important;"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                </div>

                <div class="card-body">
                    <div class="row">

                    <div class="col-md-8">
                        <h4 class="card-title" v-text="((usuario.cargo == 'Administrador') ? 'Cotizaciones por asesor - Prima neta' : 'Cotizaciones por ' + usuario.empleado + '- Prima neta' )"></h4>
                        <div class="wrapper" style="height: 300px">
                        <canvas id="myChart4" height="200"></canvas>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h1 class="card-title" align="center">Total primas por categoria</h1>
                        <table class="table table-bordered">
                        <tbody>
                        <tr>
                            <th style="background-color: #ED7D31;">
                            <b style="color:#fff" v-text="'$ '+ formatPrice(asesores_coti_categoria.total_oportunidad) "></b>
                            </th>
                            <td>Total Oportunidad</td>
                        </tr>
                        <tr>
                            <th style="background-color: #A5A5A5;">
                            <b style="color:#fff" v-text="'$ '+ formatPrice(asesores_coti_categoria.en_proceso)"></b>
                            </th>
                            <td>En Proceso</td>
                        </tr>
                        <tr>
                            <th style="background-color: #FFC000;">
                            <b style="color:#fff" v-text="'$ '+ formatPrice(asesores_coti_categoria.ganadas) "></b>
                            </th>
                            <td>Ganadas</td>
                        </tr>
                        <tr>
                            <th style="background-color: #4472C4;">
                            <b style="color:#fff" v-text="'$ '+ formatPrice(asesores_coti_categoria.perdidas) "></b>
                            </th>
                            <td>Perdidas</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    </div>
                </div>
                </div>
            </div>



            <div class="col-lg-8 col-md-8 box-margin height-card">
                <div class="card">
                <div class="card-body">
                    <div class="row">

                    <div class="col-md-12">
                        <h4 class="card-title">
                        Recaudaciones por cotizaciones nuevas y de renovación vendidas de los últimos meses
                        </h4>
                        <div class="col-md-12 col-sm-12 col-lg-12">
                            <div class="form-group">
                                <label for="referencia_id">Referencias</label>
                                <v-select  multiple @input="getVentas()"
                                            v-model="referencias_id"
                                            label="nombre"
                                            :options="referencia_lista"
                                            placeholder="Buscar Referencias..."
                                        >
                                <span slot="no-options">Lo siento, no hay opciones coincidentes.</span>
                                </v-select>
                            </div>
                        </div>
                        <div class="wrapper" >
                            <div id="combine-chart" ></div>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4 box-margin height-card">
                <div class="card">
                <div class="card-body" >
                    <h4 class="card-title">Total de comisión ganada por asesor</h4>
                    <div style="height: 300px">
                    <canvas id="asesorComision"></canvas>
                    </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-6 box-margin height-card" v-if="usuario.cargo == 'Administrador' && false" >
                <div class="card">
                <div class="card-body">
                    <div  class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th><b>Total General</b></th>
                                <th><b>15% del Total</b></th>
                                <th><b>Ganancia Final</b></th>
                            </tr>
                        </thead>
                        <tbody >
                        <td v-text="'$ '+formatPrice(totales.total)"></td>
                        <td v-text="'$ '+formatPrice(totales.porcentaje)"></td>
                        <td v-text="'$ '+formatPrice(totales.ganancia)"></td>
                        </tbody>
                    </table>
                    </div>

                </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 box-margin height-card">
                <div class="card">
                <div class="card-body">
                    <div class="row">

                    <div class="col-md-12">
                        <h4 class="card-title">
                        Las 5 Mejores Primas Netas
                        </h4>
                        <div class="wrapper" style="height: 300px">
                        <canvas id="top_primas_netas"></canvas>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 box-margin height-card">
                <div class="card">
                <div class="card-body">
                    <div class="row">

                    <div class="col-md-12">
                        <h4 class="card-title">
                        Las 5 Mejores Valores Asegurados
                        </h4>
                        <div class="wrapper" style="height: 300px">
                        <canvas id="top_valores_asegurados"></canvas>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 box-margin height-card">
                <div class="card">
                <div class="card-body">
                    <div class="row">

                    <div class="col-md-12">
                        <h4 class="card-title">
                        Las 5 Mejores Actividades Economicas con Mayor Cotización
                        </h4>
                        <div class="wrapper" style="height: 300px">
                        <canvas id="top_actividad_economica"></canvas>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-3 box-margin height-card">
                <div class="card">
                <div class="card-body">
                    <div class="row">

                    <div class="col-md-12">
                        <h4 class="card-title">
                        Cantidad de cotizaciones  por genero
                        </h4>
                        <div class="wrapper" style="height: 300px">
                        <canvas id="cantida_coti_genero"></canvas>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
            </div>

          </div>
        </div>

    </div>
  </div>
</template>

<script>
import { alertasM } from "../../../util.js";
import Chart from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import C3 from 'c3'

export default {
  mixins: [alertasM],
  props: ["ruta"],
  data() {
    return {
      charVenta: null,
      varVenta: null,
      nuevo_renovacion_bar: null,
      nuevo_renovacion_chart: null,
      ventas: [],
      varTotalVenta: [],
      varMesVenta: [],
      arrayColoresVenta: [],

      asesorVentas: [],
      totalAsesorVenta: [],
      nombreAsesorVenta: [],
      arrayColoresAsesores: [],
      charAsesor: null,
      varAsesor: null,

      asesorComision: [],
      totalAsesorComision: [],
      nombreAsesorComision: [],
      arrayColoresComision: [],
      charComision: null,
      varComision: null,

      asesorComision_by: [],
      totalAsesorComision_by: [],
      nombreAsesorComision_by: [],
      arrayColoresComision_by: [],
      charComision_by: null,
      varComision_by: null,

      usuario: [],
      totales:[],
      chart_coti_ase: null,
      myChart: null,
      asesores_coti_neta: [],
      asesores_coti_total: [],
      asesores_coti_proceso: [],
      asesores_coti_oportunidad: [],
      asesores_coti_ganadas: [],
      asesores_coti_perdidas: [],
      asesores_coti_categoria: {
        en_proceso : 0,
        ganadas: 0,
        perdidas: 0,
        total_oportunidad:0
      },
      filtrar_fecha: 0,//moment(new Date()).format('YYYY-MM-DD'),
      filtro_anio : 0,//new Date().getFullYear(),
      listAnio : [],
      mesesList : [
        {id: 1 ,  nombre: "Enero"},
        {id: 2 ,  nombre: "Febrero"},
        {id: 3 ,  nombre: "Marzo"},
        {id: 4 ,  nombre: "Abril"},
        {id: 5 ,  nombre: "Mayo"},
        {id: 6 ,  nombre: "Junio"},
        {id: 7 ,  nombre: "Julio"},
        {id: 8 ,  nombre: "Agosto"},
        {id: 9 ,  nombre: "Septiembre"},
        {id: 10 , nombre: "Octubre"},
        {id: 11 , nombre: "Noviembre"},
        {id: 12 , nombre: "Diciembre"},
      ],
      filtro_mes: 0,
      users_list: [],
      id_user: null,
      referencias_id: null,
      referencia_lista : [],

      ////top 10 primas netas
      list_top_prima_neta: [],
      var_top_prima_neta: null,
      chart_top_prima_neta: null,

      ////top 10 valores asegurados
      list_top_valores_asegurados: [],
      var_top_valores_asegurados: null,
      chart_top_valores_asegurados: null,

      ////top 10 actividad economica
      list_top_actividad_economica: [],
      var_top_actividad_economica: null,
      chart_top_actividad_economica: null,

      ////top 10 actividad economica
      list_can_coti_genero: [],
      var_can_coti_genero: null,
      chart_can_coti_genero: null,

      //total_acumulado_por_asesor : 0,
      ingreso_merbrok_por_asesor : 0,
      pagos_bonos_por_asesor : 0,
      utilidad_por_asesor : 0,
      rentabilidad_por_asesor : 0,
      data_prueba: [],
      c3_prueba: null,
    };
  },
  mixins: [alertasM],
  methods: {

    getDataUser() {
      let me = this;
      var url = "/dashboard/user";

      axios
        .post(url)
        .then((res) => {

          console.log("usuario es:"+res.data.user_by.cargo);
          console.log("id usuario es:"+res.data.user_by.id);
          console.log("listAnio:"+ res.data.anios);
          console.log("referencia_lista:"+ res.data.referencias);


          me.usuario = res.data.user_by;
          me.listAnio = res.data.anios
          me.referencia_lista = res.data.referencias
          me.users_list = res.data.users
          me.getVentas();
          me.getComisionAsesor();
          me.coti_asesor_neta();

        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({name: 'login'})
            location.reload();
            localStorage.clear();
          }
        });
    },

    getVentas() {

      let me = this;
      var url = /* this.ruta + */ "/dashboard/mes/anio";

       let data = null;

      if(this.referencias_id != null){
        data = [];
          this.referencias_id.forEach(element => {
            data.push(element.id);
          });
      }

      me.ventas =  [];
      me.varMesVenta  = [];
      me.varTotalVenta  = [];
      me.arrayColoresVenta  = [];

      axios
        .get(url, {
            params: {
                'referencias_id': data
            }
        })
        .then(function (response) {
          var respuesta = response.data;
          me.ventas         = respuesta.venta_mes_año;
          //me.totales = respuesta.total_comision_ganancia;
          //console.log(respuesta);
          //me.loadVentas();
          me.loadNuevoRenovacion();
        })
        .catch(function (error) {
          console.log(error);

          if (error.response.status == 401) {
            //this.$router.push({name: 'login'})
            location.reload();
            localStorage.clear();
          }
        });
    },

    loadVentas() {
      let me = this;
      let meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      me.ventas.map(function (x) {
        me.varMesVenta.push(meses[x.mes - 1]);
        me.varTotalVenta.push(x);
        me.arrayColoresVenta.push(me.getColor());
      });


      me.varVenta = document.getElementById("ventas").getContext("2d");
      me.varVenta.height(500);

      var options = {

      tooltips: {
          displayColors: true,
          titleFontSize: 22,
          bodyFontSize: 20,
          callbacks: {

            title: function(tooltipItem, data) {

              let mi = me;
              const valor = mi.varTotalVenta[tooltipItem.index]
              return tooltipItem[0].label + " - "+ "$ " + me.formatPrice(tooltipItem[0].yLabel); //"$ " + Number(tooltipItem.yLabel);
            },
           /* label: function(tooltipItem, data) {
              let mi = me;
              const valor = mi.varTotalVenta[tooltipItem.index]
              return "Nuevo - "+ "$ " + me.formatPrice(valor['nuevo']);
              //return "$ " + me.formatPrice(tooltipItem.yLabel); //"$ " + Number(tooltipItem.yLabel);
            },
            afterLabel: function(tooltipItem, data) {
             let mi = me;
             const valor = mi.varTotalVenta[tooltipItem.index]
             return "Renovacion - "+ "$ " + me.formatPrice(valor['renovacion']);
            },*/

          },
        },

        onClick: function(c, i, data) {
        },

      };

      me.charVenta = new Chart(me.varVenta, {
        type: "bar",

        data: {
          labels: me.varMesVenta,
          datasets: [
            {
              label: "Cotizaciones",
              data: this.splitData('total'),
              backgroundColor: me.arrayColoresVenta,
              /* borderColor: 'rgba(54, 162, 235, 0.2)', */
              borderWidth: 1,
            },
          ],
        },

        options: options,
      });
    },

    loadNuevoRenovacion(){
      let me = this
    /*
      me.ventas.map(function (x) {
        me.varTotalVenta.push(x);
      });

      if(me.nuevo_renovacion_chart!= null){
        me.nuevo_renovacion_chart.destroy();
      }
      me.nuevo_renovacion_bar = document.getElementById("renovacion_nuevos").getContext("2d");

      me.nuevo_renovacion_chart = new Chart(me.nuevo_renovacion_bar, {
        plugins: [ChartDataLabels],
        type: 'bar',
        responsive: true,
        maintainAspectRatio: false,
        data: {
            labels: this.splitData('mes_nombre'),
            datasets: [{
              label: 'Nuevo',
              backgroundColor: "#03A9F4",
              data: this.splitData('nuevo'),
            }, {
              label: 'Renovación ',
              backgroundColor: "#00c853",
              data:  this.splitData('renovacion'),
            }],
        },
        options: {
            layout: {
                padding: {
                    top: 35
                }
            },
          tooltips: {
              displayColors: true,
              titleFontSize: 22,
              bodyFontSize: 20,

              callbacks:{
                mode: 'x',
                label: function (a, b) {
                  return b.datasets[a.datasetIndex].label + ": $ " + me.formatPrice(a.yLabel);
                }
              },

            },
          scales: {
              xAxes: [{
                stacked: true,

              }],
              yAxes: [{
                stacked: true,
                type: 'linear',
              }]
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom' },
          plugins: {
            datalabels: {
              align: 'end',
              anchor: 'end',
              backgroundColor: function(context, b) {
                if(context.datasetIndex === 1){
                  return '#000';
                }else{
                  return '';
                }
              },
              font:{
                weight: 'bold'
              },
              borderRadius: 4,
              color: 'white',
              formatter: function(value, context) {
                const datasetArray=[];
                context.chart.data.datasets.forEach((dataset)=>{
                //console.log(dataset.data[context.data Index]);
                  if(dataset.data[context.dataIndex]!=undefined){
                    datasetArray.push(dataset.data[context.dataIndex]);
                  }
                });
                function totalSum(total,datapoint){
                  return total+datapoint;
                }
                let sum=datasetArray.reduce(totalSum,0);

                if(context.datasetIndex === datasetArray.length - 1){
                  return "$ " + me.formatPrice(sum);
                }else{
                  return '';
                }
              }
            },
            // datalabels: {
            //   color: 'white',
            //   font: {
            //     weight: 'bold'
            //   },
            //   formatter: function(value, context) {
            //   return "$ " + me.formatPrice(value);
            //   }
            // },
            // datalabels: {
            //   align: 'end',
            //   anchor: 'end',
            //   backgroundColor: function(context) {
            //     return context.dataset.backgroundColor;
            //   },
            //   font:{
            //     weight: 'bold'
            //   },
            //   borderRadius: 4,
            //   color: 'white',
            //   formatter: function(value, b){
            //     //console.log(b.datasetIndex)
            //    // console.log(b['dataset'].label)
            //     //console.log(b.dataset.label)
            //     // return b.datasets.label + ": $ " + me.formatPrice(value);
            //     return b.dataset.label + ": $ "+me.formatPrice(value);
            //     //return "$ " + me.formatPrice(value);
            //   }
            // }
          },
        }
      });
    */
      //--------------------------------------------------

      if(me.nuevo_renovacion_chart!= null){
        me.nuevo_renovacion_chart.destroy();
      }

      me.nuevo_renovacion_chart = new C3.generate({
            bindto: "#combine-chart",
            data: {
                json: me.ventas,
                //labels: true,
                keys: {
                    x: 'mes', // it's possible to specify 'x' when category axis
                    value: ['nuevo', 'renovacion', 'total']
                },
                types: {
                    nuevo: "bar",
                    renovacion: "bar",
                    total: "line",
                },

                names: {
                    nuevo: "Nuevo",
                    renovacion: "Renovación",
                    total: "Total",
                },
                //colors: {
                //    nuevo: "#dcdcdc",
                //    renovacion: "#4ac6ec",
                //    total: "#36404a",
                //},
                //groups: [ [ "nuevo", "renovacion" ] ]
            },
            axis: {
                x: {
                    //type: "categorized",
                    //type : 'category',
                    tick: {
                        format: function (d) {
                            let val =  me.mesesList.filter(m => m.id == d)
                            return val[0].nombre;
                        }
                    }

                },
                y : {
                    tick: {
                        format: function (d) {
                            let val = (d / 1).toFixed(2).replace(".", ",");
                            return "$" +  val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                            //return "$" + formatPrice(Number(d));
                        }
                    }
                }
            },
            legend: {
                tick: {
                        format: function (d) {
                            console.log(d);
                            return d + ' bkar';
                        }
                    }
            }
            //https://c3js.org/samples/data_label_format.html
        })
    },

    splitData(type) {
      return this.varTotalVenta.map(v => v[type]);
    },

    splitDataGeneral(data=[], type) {
      return data.map(v => v[type]);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    pickRandomProperty(obj) {
      var result;
      var count = 0;
      for (var prop in obj) if (Math.random() < 1 / ++count) result = prop;
      return result;
    },

    getColor() {
      var colors = {
        red: {
          50: "#ffebee",
          100: "#ffcdd2",
          200: "#ef9a9a",
          300: "#e57373",
          400: "#ef5350",
          500: "#f44336",
          600: "#e53935",
          700: "#d32f2f",
          800: "#c62828",
          900: "#b71c1c",
          hex: "#f44336",
          a100: "#ff8a80",
          a200: "#ff5252",
          a400: "#ff1744",
          a700: "#d50000",
        },
        pink: {
          50: "#fce4ec",
          100: "#f8bbd0",
          200: "#f48fb1",
          300: "#f06292",
          400: "#ec407a",
          500: "#e91e63",
          600: "#d81b60",
          700: "#c2185b",
          800: "#ad1457",
          900: "#880e4f",
          hex: "#e91e63",
          a100: "#ff80ab",
          a200: "#ff4081",
          a400: "#f50057",
          a700: "#c51162",
        },
        purple: {
          50: "#f3e5f5",
          100: "#e1bee7",
          200: "#ce93d8",
          300: "#ba68c8",
          400: "#ab47bc",
          500: "#9c27b0",
          600: "#8e24aa",
          700: "#7b1fa2",
          800: "#6a1b9a",
          900: "#4a148c",
          hex: "#9c27b0",
          a100: "#ea80fc",
          a200: "#e040fb",
          a400: "#d500f9",
          a700: "#aa00ff",
        },
        deepPurple: {
          50: "#ede7f6",
          100: "#d1c4e9",
          200: "#b39ddb",
          300: "#9575cd",
          400: "#7e57c2",
          500: "#673ab7",
          600: "#5e35b1",
          700: "#512da8",
          800: "#4527a0",
          900: "#311b92",
          hex: "#673ab7",
          a100: "#b388ff",
          a200: "#7c4dff",
          a400: "#651fff",
          a700: "#6200ea",
        },
        indigo: {
          50: "#e8eaf6",
          100: "#c5cae9",
          200: "#9fa8da",
          300: "#7986cb",
          400: "#5c6bc0",
          500: "#3f51b5",
          600: "#3949ab",
          700: "#303f9f",
          800: "#283593",
          900: "#1a237e",
          hex: "#3f51b5",
          a100: "#8c9eff",
          a200: "#536dfe",
          a400: "#3d5afe",
          a700: "#304ffe",
        },
        blue: {
          50: "#e3f2fd",
          100: "#bbdefb",
          200: "#90caf9",
          300: "#64b5f6",
          400: "#42a5f5",
          500: "#2196f3",
          600: "#1e88e5",
          700: "#1976d2",
          800: "#1565c0",
          900: "#0d47a1",
          hex: "#2196f3",
          a100: "#82b1ff",
          a200: "#448aff",
          a400: "#2979ff",
          a700: "#2962ff",
        },
        lightBlue: {
          50: "#e1f5fe",
          100: "#b3e5fc",
          200: "#81d4fa",
          300: "#4fc3f7",
          400: "#29b6f6",
          500: "#03a9f4",
          600: "#039be5",
          700: "#0288d1",
          800: "#0277bd",
          900: "#01579b",
          hex: "#03a9f4",
          a100: "#80d8ff",
          a200: "#40c4ff",
          a400: "#00b0ff",
          a700: "#0091ea",
        },
        cyan: {
          50: "#e0f7fa",
          100: "#b2ebf2",
          200: "#80deea",
          300: "#4dd0e1",
          400: "#26c6da",
          500: "#00bcd4",
          600: "#00acc1",
          700: "#0097a7",
          800: "#00838f",
          900: "#006064",
          hex: "#00bcd4",
          a100: "#84ffff",
          a200: "#18ffff",
          a400: "#00e5ff",
          a700: "#00b8d4",
        },
        teal: {
          50: "#e0f2f1",
          100: "#b2dfdb",
          200: "#80cbc4",
          300: "#4db6ac",
          400: "#26a69a",
          500: "#009688",
          600: "#00897b",
          700: "#00796b",
          800: "#00695c",
          900: "#004d40",
          hex: "#009688",
          a100: "#a7ffeb",
          a200: "#64ffda",
          a400: "#1de9b6",
          a700: "#00bfa5",
        },
        green: {
          50: "#e8f5e9",
          100: "#c8e6c9",
          200: "#a5d6a7",
          300: "#81c784",
          400: "#66bb6a",
          500: "#4caf50",
          600: "#43a047",
          700: "#388e3c",
          800: "#2e7d32",
          900: "#1b5e20",
          hex: "#4caf50",
          a100: "#b9f6ca",
          a200: "#69f0ae",
          a400: "#00e676",
          a700: "#00c853",
        },
        lightGreen: {
          50: "#f1f8e9",
          100: "#dcedc8",
          200: "#c5e1a5",
          300: "#aed581",
          400: "#9ccc65",
          500: "#8bc34a",
          600: "#7cb342",
          700: "#689f38",
          800: "#558b2f",
          900: "#33691e",
          hex: "#8bc34a",
          a100: "#ccff90",
          a200: "#b2ff59",
          a400: "#76ff03",
          a700: "#64dd17",
        },
        lime: {
          50: "#f9fbe7",
          100: "#f0f4c3",
          200: "#e6ee9c",
          300: "#dce775",
          400: "#d4e157",
          500: "#cddc39",
          600: "#c0ca33",
          700: "#afb42b",
          800: "#9e9d24",
          900: "#827717",
          hex: "#cddc39",
          a100: "#f4ff81",
          a200: "#eeff41",
          a400: "#c6ff00",
          a700: "#aeea00",
        },
        yellow: {
          50: "#fffde7",
          100: "#fff9c4",
          200: "#fff59d",
          300: "#fff176",
          400: "#ffee58",
          500: "#ffeb3b",
          600: "#fdd835",
          700: "#fbc02d",
          800: "#f9a825",
          900: "#f57f17",
          hex: "#ffeb3b",
          a100: "#ffff8d",
          a200: "#ffff00",
          a400: "#ffea00",
          a700: "#ffd600",
        },
        amber: {
          50: "#fff8e1",
          100: "#ffecb3",
          200: "#ffe082",
          300: "#ffd54f",
          400: "#ffca28",
          500: "#ffc107",
          600: "#ffb300",
          700: "#ffa000",
          800: "#ff8f00",
          900: "#ff6f00",
          hex: "#ffc107",
          a100: "#ffe57f",
          a200: "#ffd740",
          a400: "#ffc400",
          a700: "#ffab00",
        },
        orange: {
          50: "#fff3e0",
          100: "#ffe0b2",
          200: "#ffcc80",
          300: "#ffb74d",
          400: "#ffa726",
          500: "#ff9800",
          600: "#fb8c00",
          700: "#f57c00",
          800: "#ef6c00",
          900: "#e65100",
          hex: "#ff9800",
          a100: "#ffd180",
          a200: "#ffab40",
          a400: "#ff9100",
          a700: "#ff6d00",
        },
        deepOrange: {
          50: "#fbe9e7",
          100: "#ffccbc",
          200: "#ffab91",
          300: "#ff8a65",
          400: "#ff7043",
          500: "#ff5722",
          600: "#f4511e",
          700: "#e64a19",
          800: "#d84315",
          900: "#bf360c",
          hex: "#ff5722",
          a100: "#ff9e80",
          a200: "#ff6e40",
          a400: "#ff3d00",
          a700: "#dd2c00",
        },
        brown: {
          50: "#efebe9",
          100: "#d7ccc8",
          200: "#bcaaa4",
          300: "#a1887f",
          400: "#8d6e63",
          500: "#795548",
          600: "#6d4c41",
          700: "#5d4037",
          800: "#4e342e",
          900: "#3e2723",
          hex: "#795548",
        },
        grey: {
          50: "#fafafa",
          100: "#f5f5f5",
          200: "#eeeeee",
          300: "#e0e0e0",
          400: "#bdbdbd",
          500: "#9e9e9e",
          600: "#757575",
          700: "#616161",
          800: "#424242",
          900: "#212121",
          hex: "#9e9e9e",
        },
        blueGrey: {
          50: "#eceff1",
          100: "#cfd8dc",
          200: "#b0bec5",
          300: "#90a4ae",
          400: "#78909c",
          500: "#607d8b",
          600: "#546e7a",
          700: "#455a64",
          800: "#37474f",
          900: "#263238",
          hex: "#607d8b",
        },
        black: {
          hex: "#000000",
        },
        white: {
          hex: "#ffffff",
        },
      };
      // pick random property
      //var property = pickRandomProperty(colors);
      var colorList = colors[this.pickRandomProperty(colors)];
      var newColorKey = this.pickRandomProperty(colorList);
      var newColor = colorList[newColorKey];
      return newColor;
    },

    randomColor() {
      return (
        "#" + // start with a leading hash
        Math.random() // generates random number
          .toString(16) // changes that number to base 16 as a string
          .substr(2, 6)
      ); // gets 6 characters and excludes the leading "0."
    },

    getComisionAsesor() {
      let me = this;
      var url = "/dashboard/aasesor/comision";

      me.asesorComision     = [];
      me.totalAsesorComision      = [];
      me.nombreAsesorComision     = [];
      me.arrayColoresComision     = [];
      me.charComision     = null;
      me.varComision      = null;

      axios
        .get(url)
        .then(function (response) {
          var respuesta                     = response.data;
          me.asesorComision                 = respuesta.asesor_bonificacion;
          me.list_top_prima_neta            = respuesta.top_prima_neta;
          me.list_top_valores_asegurados    = respuesta.top_valor_asegurado;
          me.list_top_actividad_economica   = respuesta.top_actividad_economica;
          me.list_can_coti_genero           = respuesta.generos_clientes;
          me.loadVentComisionsAsesor();
          me.loadTopPrimaNeta();
          me.loadTopValorAsegurado();
          me.loadTopActividadesEconomicas();
          me.loadCanCotiGenero();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    loadVentComisionsAsesor() {
      let me = this;
      me.asesorComision.map(function (x) {
        me.nombreAsesorComision.push(x.empleado);
        me.totalAsesorComision.push(x.total);
        me.arrayColoresComision.push(me.randomColor());
      });
      me.varComision = document.getElementById("asesorComision").getContext("2d");
     // me.varComision.height(500);

      me.charComision = new Chart(me.varComision, {
        type: "doughnut",
        data: {
          labels: me.nombreAsesorComision,
          datasets: [
            {
              label: "Asesores",
              data: me.totalAsesorComision,
              backgroundColor: me.arrayColoresComision,
              /* borderColor: 'rgba(54, 162, 235, 0.2)', */
              borderWidth: 1,
            },
          ],
        },

        options: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: true,
            titleFontSize: 22,
            bodyFontSize: 20,
            callbacks: {
              label: function (tooltipItem, data) {
                ///console.log(data);
                return data["labels"][tooltipItem["index"]];
              },
              afterLabel: function (tooltipItem, data) {
                return (
                  "$ " +
                  me.formatPrice(
                    data["datasets"][0]["data"][tooltipItem["index"]]
                  )
                ); ///'$ ' + data['datasets'][0]['data'][tooltipItem['index']];
              },
            },
          },
        },
      });
    },

    loadTopPrimaNeta() {
      let me = this;

      me.var_top_prima_neta = document.getElementById("top_primas_netas").getContext("2d");

      var list_background_color     = [];
      list_background_color         = me.list_top_valores_asegurados.map(v => me.randomColor());

      me.chart_top_prima_neta = new Chart(me.var_top_prima_neta, {
        type: "doughnut",
        data: {
          labels: me.splitDataGeneral(me.list_top_prima_neta, 'cliente'),
          datasets: [
            {
              label: "Asesores",
              data: me.splitDataGeneral(me.list_top_prima_neta, 'prima_neta'),
              backgroundColor: list_background_color,
              /* borderColor: 'rgba(54, 162, 235, 0.2)', */
              borderWidth: 1,
            },
          ],
        },

        options: {
            legend: {
            display: false
         },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: true,
            titleFontSize: 22,
            bodyFontSize: 20,
            callbacks: {
              label: function (tooltipItem, data) {
                ///console.log(data);
                return data["labels"][tooltipItem["index"]];
              },
              afterLabel: function (tooltipItem, data) {
                return (
                  "$ " +
                  me.formatPrice(
                    data["datasets"][0]["data"][tooltipItem["index"]]
                  )
                ); ///'$ ' + data['datasets'][0]['data'][tooltipItem['index']];
              },
            },
          },
        },
      });
    },

    loadTopValorAsegurado() {
      let me = this;

      me.var_top_valores_asegurados = document.getElementById("top_valores_asegurados").getContext("2d");
      var list_background_color     = [];
      list_background_color         = me.list_top_valores_asegurados.map(v => me.randomColor());

      me.chart_top_valores_asegurados = new Chart(me.var_top_valores_asegurados, {
        type: "doughnut",
        data: {
          labels: me.splitDataGeneral(me.list_top_valores_asegurados, 'cliente'),
          datasets: [
            {
              label: "Asesores",
              data: me.splitDataGeneral(me.list_top_valores_asegurados, 'suma_asegurada'),
              backgroundColor: list_background_color,
              //borderColor: 'rgba(54, 162, 235, 0.2)',
              borderWidth: 1,
            },
          ],
        },

        options: {
            legend: {
            display: false
         },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: true,
            titleFontSize: 22,
            bodyFontSize: 20,
            callbacks: {
              label: function (tooltipItem, data) {
                ///console.log(data);
                return data["labels"][tooltipItem["index"]];
              },
              afterLabel: function (tooltipItem, data) {
                return (
                  "$ " +
                  me.formatPrice(
                    data["datasets"][0]["data"][tooltipItem["index"]]
                  )
                ); ///'$ ' + data['datasets'][0]['data'][tooltipItem['index']];
              },
            },
          },
        },
      });
    },

    loadTopActividadesEconomicas() {
      let me = this;

      me.var_top_actividad_economica = document.getElementById("top_actividad_economica").getContext("2d");
      var list_background_color     = [];
      list_background_color         = me.list_top_actividad_economica.map(v => me.randomColor());

      me.chart_top_actividad_economica = new Chart(me.var_top_actividad_economica, {
        type: "doughnut",
        data: {
          labels: me.splitDataGeneral(me.list_top_actividad_economica, 'nombre'),
          datasets: [
            {
              label: "Actividades Economicas",
              data: me.splitDataGeneral(me.list_top_actividad_economica, 'clientes_count'),
              backgroundColor: list_background_color,
              //borderColor: 'rgba(54, 162, 235, 0.2)',
              borderWidth: 1,
            },
          ],
        },

        options: {
            legend: {
            display: false
         },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: true,
            titleFontSize: 22,
            bodyFontSize: 20,
            callbacks: {
              label: function (tooltipItem, data) {
                ///console.log(data);
                return data["labels"][tooltipItem["index"]];
              },
              afterLabel: function (tooltipItem, data) {
                return (
                    data["datasets"][0]["data"][tooltipItem["index"]]  + " Cotizaciones"
                ); ///'$ ' + data['datasets'][0]['data'][tooltipItem['index']];
              },
            },
          },
        },
      });
    },

    loadCanCotiGenero() {
      let me = this;

      me.var_can_coti_genero = document.getElementById("cantida_coti_genero").getContext("2d");
     //var list_background_color     = [];
     //list_background_color         = me.list_can_coti_genero.map(v => me.randomColor());

      me.chart_can_coti_genero = new Chart(me.var_can_coti_genero, {
        type: "doughnut",
        data: {
          labels: me.splitDataGeneral(me.list_can_coti_genero, 'genero'),
          datasets: [
            {
              label: "Cantidad de cotizaciones  por genero",
              data: me.splitDataGeneral(me.list_can_coti_genero, 'total'),
              backgroundColor: ['#0069c0', '#ff77a9'],
              //borderColor: 'rgba(54, 162, 235, 0.2)',
              borderWidth: 1,
            },
          ],
        },

        options: {
            legend: {
            display: false
         },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: true,
            titleFontSize: 22,
            bodyFontSize: 20,
            callbacks: {
              label: function (tooltipItem, data) {
                ///console.log(data);
                return data["labels"][tooltipItem["index"]];
              },
              afterLabel: function (tooltipItem, data) {
                return (
                    data["datasets"][0]["data"][tooltipItem["index"]]  + " Cotizaciones"
                ); ///'$ ' + data['datasets'][0]['data'][tooltipItem['index']];
              },
            },
          },
        },
      });
    },

    coti_asesor_neta(filtrar_fecha_v = 0,filtro_anio_v=0,filtro_mes_v=0,iduser=null){

      let data = iduser;

      if(iduser!=null){
        data = [];
          iduser.forEach(element => {
            data.push(element.id);
          });
      }

      let me = this;
      var url = "/dashboard/cotizacion_asesor";
      axios
        .get(url,{
              params: {
                //me.usuario.id
                'id': ((me.usuario.cargo == 'Administrador') ? 0 : me.usuario.id),
                'filtrar_fecha' :  (filtrar_fecha_v == 0) ? 0 : moment(filtrar_fecha_v).format('DD/MM/YYYY'),
                'filtro_anio'   : filtro_anio_v,
                'filtro_mes'    : filtro_mes_v,
                'iduser'        : data,
              }
        })
        .then(function (response) {

          var respuesta = response.data;

          //Borrar Data
          me.asesores_coti_neta = [];
          me.asesores_coti_total = [];
          me.asesores_coti_proceso = [];
          me.asesores_coti_oportunidad = [];
          me.asesores_coti_ganadas = [];
          me.asesores_coti_perdidas = [];

          respuesta.asesores.map(function(x){

              me.asesores_coti_neta.push(x.asesor);
          });

          Object.values(respuesta.cotizaciones).map(function(x){

              me.asesores_coti_total.push(x);
          });

          Object.values(respuesta.en_proceso).map(function(x){
            me.asesores_coti_proceso.push(x);
          });

          Object.values(respuesta.total_oportunidad).map(function(x){
              me.asesores_coti_oportunidad.push(x);
          });

         Object.values(respuesta.ganadas).map(function(x){
              me.asesores_coti_ganadas.push(x);
          });

          Object.values(respuesta.perdidas).map(function(x){
              me.asesores_coti_perdidas.push(x);
          });

        me.asesores_coti_categoria.en_proceso           = respuesta.data.en_proceso;
        me.asesores_coti_categoria.ganadas              = respuesta.data.ganadas;
        me.asesores_coti_categoria.perdidas             = respuesta.data.perdidas;
        me.asesores_coti_categoria.total_oportunidad    = respuesta.data.total_oportunidad;
        me.ingreso_merbrok_por_asesor                   = respuesta.data.ingreso_merbrok;
        me.pagos_bonos_por_asesor                       = respuesta.data.pagos_bonos;
        me.utilidad_por_asesor                          = respuesta.data.utilidad;
        me.rentabilidad_por_asesor                      = respuesta.data.rentabilidad;

        me.load_asesor_neta();
        if(filtrar_fecha_v == 0){
          me.filtrar_fecha =  (filtrar_fecha_v == 0 || filtro_mes_v == 0) ? 0 : filtrar_fecha_v ;
        }
        me.filtro_anio  =  (filtrar_fecha_v  != 0) ? 0 : filtro_anio_v;
        me.filtro_mes =  (filtrar_fecha_v  != 0) ? 0 : filtro_mes_v;

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    load_asesor_neta(){
        let me = this

        if(me.myChart!= null){
              me.myChart.destroy();
          }

        //---------------------------------------------------------
        //---------------------------------------------------------
        me.chart_coti_ase = document.getElementById("myChart4").getContext("2d");

        me.myChart = new Chart(me.chart_coti_ase, {
          type: 'bar',
          data: {
            labels: me.asesores_coti_neta,
            datasets: [{
              label: 'Cotización',
              backgroundColor: "#5B9BD5",
              data: me.asesores_coti_total,
            }, {
              label: 'Total Oportunidad',
              backgroundColor: "#ED7D31",
              data:  me.asesores_coti_oportunidad,
            }, {
              label: 'En Proceso',
              backgroundColor: "#A5A5A5",
              data: me.asesores_coti_proceso,
            }, {
              label: 'Ganadas',
              backgroundColor: "#FFC000",
              data:  me.asesores_coti_ganadas,
            },
             {
              label: 'Perdidas',
              backgroundColor: "#4472C4",
              data:  me.asesores_coti_perdidas,
            }],
          },
        options: {
            /*tooltips: {
              displayColors: true,
              titleFontSize: 22,
              bodyFontSize: 20,
              displayColors: true,
              callbacks:{
                mode: 'x',
                label: function (a, b) {
                  //console.log(a.datasetIndex)
                    return b.datasets[a.datasetIndex].label + ": $ " + me.formatPrice(a.yLabel);
                }
              },

            },
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  beginAtZero: true,
                },
                type: 'linear',
              }]
            },*/
            tooltips: {
                mode: 'label',
                displayColors: true,
                titleFontSize: 22,
                bodyFontSize: 20,
                callbacks: {
                title: function(tooltipItems, data) {
                    //console.log(tooltipItems[0].xLabel);
                    return tooltipItems[0].xLabel;
                },
                label: function(tooltipItem, data) {

                    if(data.datasets[tooltipItem.datasetIndex].label == 'Cotización'){
                        return "N° Cotizaciones" + ": " + tooltipItem.yLabel;
                    }else{
                        return data.datasets[tooltipItem.datasetIndex].label + ": $" + me.formatPrice(tooltipItem.yLabel);

                    }
                },
            }
            },
            scales: {
                xAxes: [{
                stacked: true,
                ticks: {
                    callback: function(value) { return value; },
                },
                gridLines: { display: false },
                }],
                yAxes: [{
                stacked: true,
                ticks: {
                    callback: function(value) { return me.formatPrice(value); },
                },
                }],
            }, // scales
            legend: {position: 'bottom'},
            responsive: true,
            maintainAspectRatio: false,
            //legend: { position: 'bottom' },
          }
        });

    },

    reset(){
      this.filtro_anio  =  0;
      this.filtro_mes =  0;
      this.id_user =  null;
      this.filtrar_fecha =  0;//moment(new Date()).format('YYYY-MM-DD');
      this.coti_asesor_neta();
    }

  },
  mounted() {
    this.getDataUser();

    window.Echo.channel('dashboard-cotizacion')
        .listen('DashboardEvent', (user)=>{
            if(user.user['id'] == JSON.parse(localStorage.getItem('authUser'))['id'] || this.usuario.cargo == 'Administrador'){
                  this.getDataUser();
            }

    });

  },
};
</script>

<style>

.w5rapper{
  width:60%;
  display:block;
  overflow:hidden;
  margin:0 auto;
  padding: 60px 50px;
  background:#fff;
  border-radius:4px;}

  .hover-eti :hover {
    color: #3498DB;
}
</style>
